import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './NavigationSmallButton.css';
import Link from '../Link';
import Icon from '../Icon';
import Badge from '../Badge';
import { isPriviliged } from '../../core/deviceHelper';
import { getNumberToBadge } from '../../core/navigationHelper';

class NavigationSmallButton extends React.Component {

  getButtonWrapper = (_isPriviliged, isSuperior, ownershipCount) => {
    let buttonWrapper = isSuperior
      ? cx(s.smallMenuButton, s.spirotech, s.nodevice)
      : cx(s.smallMenuButton, s.nodevice);
    if (+ownershipCount > 0) {
      const buttonWrapperPriviligedSpirotech = _isPriviliged
        ? cx(s.smallMenuButton, s.spirotech, s.priviliged)
        : cx(s.smallMenuButton, s.spirotech);

      const buttonWrapperPriviliged = _isPriviliged
        ? cx(s.smallMenuButton, s.priviliged)
        : cx(s.smallMenuButton);

      buttonWrapper = isSuperior
        ? buttonWrapperPriviligedSpirotech
        : buttonWrapperPriviliged;
    }
    return buttonWrapper;
  };

  getButtonWrapperActive = (_isPriviliged, isSuperior, ownershipCount) => {
    let buttonWrapperActive = isSuperior
      ? cx(s.smallMenuButton, s.active, s.spirotech, s.nodevice)
      : cx(s.smallMenuButton, s.active, s.nodevice);
    if (+ownershipCount > 0) {
      const buttonWrapperActivePriviligedSpirotech = _isPriviliged
        ? cx(s.smallMenuButton, s.active, s.spirotechActive, s.priviliged)
        : cx(s.smallMenuButton, s.active, s.spirotechActive);

      const buttonWrapperActivePriviliged = _isPriviliged
        ? cx(s.smallMenuButton, s.active, s.priviliged)
        : cx(s.smallMenuButton, s.active);

      buttonWrapperActive = isSuperior
        ? buttonWrapperActivePriviligedSpirotech
        : buttonWrapperActivePriviliged;
    }

    return buttonWrapperActive;
  };


  render() {
    const { 
      item,
      producent,
      active,
      alertsCount,
      userRole,
      ownershipCount,
      profileNumber 
    } = this.props;
    const { iconName, link, text } = item;
    const isSuperior = producent === 'spirotech';
    const isPriviligedValue = isPriviliged(userRole);

    const buttonWrapper = this.getButtonWrapper(
      isPriviligedValue,
      isSuperior,
      ownershipCount
    );
    const buttonWrapperActive = this.getButtonWrapperActive(
      isPriviligedValue,
      isSuperior,
      ownershipCount
    );

    const iconSize = 26;
    const buttonClassName = active === text ? buttonWrapperActive : buttonWrapper;

    if (link === '/messages' || link === '/notifications' || link.startsWith('/profile')) {
      const numberToBadge = getNumberToBadge(link, alertsCount, profileNumber);
      return (
        <div
          role="button"
          className={buttonClassName}
          onClick={() => {
            this.props.setTextValue(text);
          }}
          tabIndex="0"
        >
          <Link className={s.link} to={link}>
            <Icon iconName={iconName} className="Icon--block" size={iconSize} >
              <Badge number={numberToBadge} />
            </Icon>
          </Link>
        </div>
      );
    } else if (link === '/logout') {
      return (
        <div role="button" className={buttonClassName} tabIndex="0">
          <a className={s.link} href="/logout">
            <Icon iconName={iconName} className="Icon--block" size={iconSize} />
          </a>
        </div>
      );
    }
    return (
      <div
        role="button"
        className={buttonClassName}
        onClick={() => {
          this.props.setTextValue(text);
        }}
        tabIndex="0"
      >
        <Link className={s.link} to={link}>
          <Icon iconName={iconName} className="Icon--block" size={iconSize} />
        </Link>
      </div>
    );
  };
}

NavigationSmallButton.propTypes = {
  item: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  alertsCount: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  active: PropTypes.string.isRequired,
  producent: PropTypes.string.isRequired,
  setTextValue: PropTypes.func.isRequired,
  userRole: PropTypes.number.isRequired,
  ownershipCount: PropTypes.number.isRequired,
  profileNumber: PropTypes.number.isRequired,
}

export default withStyles(s)(NavigationSmallButton);


// WEBPACK FOOTER //
// ./src/components/NavigationSmallButton/NavigationSmallButton.js